import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import NotFoundPage from '../pages/NotFoundPage'
import Loading from '../components/Loading'
import Header from 'src/components/Header/Header'
import store from '../data-store/store'

const Dashboard = lazy(() => import('../pages/Dashboard/dashboard'))
const LoginPage = lazy(() => import('../pages/LoginPage/LoginPage'))
const CallBackPage = lazy(() => import('../pages/CallBackPage/CallBackPage'))
const LoggedOutPage = lazy(() => import('../pages/LoggedOutPage/LoggedOutPage'))
const FinalScanPage = lazy(() => import('../pages/FinalScanPage/FinalScanPage'))
const StuffPage = lazy(() => import('../pages/StuffPage/StuffPage'))
const SearchAndRetrievePage = lazy(() => import('../pages/SearchAndRetrievePage/SearchAndRetrievePage'))
const ReprintToolPage = lazy(() => import('../pages/ReprintToolPage/ReprintToolPage'))
const PackageDetailsPage = lazy(() => import('../pages/SearchRetrievePackageDetailsPage/SearchRetrievePackageDetailsPage'))
const PackageLookupPage = lazy(() => import('../pages/PackageLookupPage/PackageLookupPage'))
const CalculatorPage = lazy(() => import('../pages/CalculatorPage/CalculatorPage'))
const CountDownPage = lazy(() => import('../pages/CountDownPage/CountDownPage'))

const AppRouter = () => {
  const userRoles = store.getState().auth?.currentUser?.roles

  return (
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<PublicRoute><LoginPage /></PublicRoute>} exact />
          <Route path='/logged-out' element={<PublicRoute><LoggedOutPage /></PublicRoute>} exact />
          <Route path='/login/callback' element={<PublicRoute><CallBackPage /></PublicRoute>} exact />
          <Route path='/dashboard' element={<PrivateRoute><Header /><Dashboard /></PrivateRoute>} exact />
          <Route path='/finalscan' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.dailyoperations') || userRoles?.includes('fulfillmentapp.dailyoperationstx')}><Header /><FinalScanPage /></PrivateRoute>} exact />
          <Route path='/stuff' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.dailyoperations') || userRoles?.includes('fulfillmentapp.dailyoperationstx')}><Header /><StuffPage /></PrivateRoute>} exact />
          <Route path='/searchRetrieve' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.historysearchretrieve')}><Header /><SearchAndRetrievePage /></PrivateRoute>} exact />
          <Route path='/reprintTool' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.dailyoperations') || userRoles?.includes('fulfillmentapp.dailyoperationstx')}><Header /><ReprintToolPage /></PrivateRoute>} exact />
          <Route path='/searchRetrieve/:id' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.dailyoperations') || userRoles?.includes('fulfillmentapp.dailyoperationstx')}><Header /><PackageDetailsPage /></PrivateRoute>} exact />
          <Route path='/packageLookup' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.dailyoperations') || userRoles?.includes('fulfillmentapp.dailyoperationstx')}><Header /><PackageLookupPage /></PrivateRoute>} exact />
          <Route path='/calculator' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.dailyoperations') || userRoles?.includes('fulfillmentapp.dailyoperationstx')}><Header /><CalculatorPage /></PrivateRoute>} exact />
          <Route path='/countDown' element={<PrivateRoute isAllowed={userRoles?.includes('fulfillmentapp.dailyoperations') || userRoles?.includes('fulfillmentapp.dailyoperationstx')}><Header /><CountDownPage /></PrivateRoute>} exact />
          <Route path='*' element={<PrivateRoute><Header /><NotFoundPage /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </Suspense>
  )
}

export default AppRouter
